var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._l(Object.keys(_vm.options), function (key, index) {
      return _c("el-option", {
        key: index,
        attrs: { label: _vm.options[key], value: key },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }